/* eslint-disable no-undef */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/customer_appCommonService";

// Restore auctionNr from sessionStorage on page refresh
const _savedAuctionNr = sessionStorage.getItem("activeAuctionId") || "";

const initialState = {
  eauction: {
    data: [],
    status: false,
    auctionNr: _savedAuctionNr,  // restored on refresh
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },

    // Socket / Live Auction State
    liveBids: [],          // real-time bid feed from socket
    liveBidRanking: [],    // leaderboard updated in real-time
    auctionSocketStatus: "idle",   // "idle" | "connected" | "disconnected" | "error"
    lastBidStatus: null,           // { status: "accepted"|"rejected", message, bidData }
    auctionLiveStatus: "active",   // "active" | "extended" | "ended"
    serverRemainingSeconds: null,  // synced from server via socket
  },
};

export const eauctionSlice = createSlice({
  name: "eauction",
  initialState,
  reducers: {
    // Existing
    addauctionNr(state, action) {
      state.eauction.auctionNr = action.payload;
      // persist so page refresh doesn't lose the auctionId
      if (action.payload) sessionStorage.setItem("activeAuctionId", action.payload);
    },

    // Socket Status
    setAuctionSocketStatus(state, action) {
      state.eauction.auctionSocketStatus = action.payload;
    },

    // Live Bids Feed
    addLiveBid(state, action) {
      state.eauction.liveBids = [action.payload, ...state.eauction.liveBids].slice(0, 100);
    },
    setLiveBids(state, action) {
      state.eauction.liveBids = action.payload;
    },
    clearLiveBids(state) {
      state.eauction.liveBids = [];
    },

    // Leaderboard
    setLiveBidRanking(state, action) {
      state.eauction.liveBidRanking = action.payload;
    },

    // Bid Status
    setLastBidStatus(state, action) {
      state.eauction.lastBidStatus = action.payload;
    },

    // Auction Lifecycle
    setAuctionLiveStatus(state, action) {
      state.eauction.auctionLiveStatus = action.payload;
    },

    // Server Timer Sync
    setServerRemainingSeconds(state, action) {
      state.eauction.serverRemainingSeconds = action.payload;
    },

    // Reset all live state
    resetLiveAuctionState(state) {
      state.eauction.liveBids = [];
      state.eauction.liveBidRanking = [];
      state.eauction.auctionSocketStatus = "idle";
      state.eauction.lastBidStatus = null;
      state.eauction.auctionLiveStatus = "active";
      state.eauction.serverRemainingSeconds = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getEauction.pending, (state) => {
        state.eauction.status = true;
      })
      .addCase(getEauction.fulfilled, (state, action) => {
        state.eauction.data = action.payload.data;
        state.eauction.pagination.page = action.payload.page;
        state.eauction.pagination.per_page = action.payload.per_page;
        state.eauction.pagination.total = action.payload.total;
        state.eauction.status = false;
      });
  },
});

export const {
  addauctionNr,
  setAuctionSocketStatus,
  addLiveBid,
  setLiveBids,
  clearLiveBids,
  setLiveBidRanking,
  setLastBidStatus,
  setAuctionLiveStatus,
  setServerRemainingSeconds,
  resetLiveAuctionState,
} = eauctionSlice.actions;

export default eauctionSlice.reducer;

export const getEauction = createAsyncThunk("getEauction", async (param) => {
  console.log(">> loaded getEauction");
  const res = await ItemService.generateCustomerQuery(param);
  return res;
});
